export const types = {
  FETCH_PLAYER_DATA: 'FETCH_PLAYER_DATA',
  SET_PLAYER_DATA: 'SET_PLAYER_DATA',
  FETCH_PURCHASE_HISTORY: 'FETCH_PURCHASE_HISTORY',
  SET_PURCHASE_HISTORY: 'SET_PURCHASE_HISTORY',
  FETCH_SCORE_HISTORY: 'FETCH_SCORE_HISTORY',
  SET_SCORE_HISTORY: 'SET_SCORE_HISTORY',
  SET_IS_FETCHING: 'SET_IS_FETCHING'
};
